































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import * as rules from '@/modules/shared/shared/domain/rules.ts';
import { Prop, Watch } from 'vue-property-decorator';
import { GET_CUSTOMER_ID, IS_EMPLOYEE } from '@/modules/users/store/user.getters';
import { user } from '@/modules/shared/shared/store/namespaces';
import { TicketType } from '../../modules/shared/shared/domain/constants/constants';
import { Tickets } from '../../modules/shared/shared/domain/constants/constants';
import { ContactManagementType } from '../../modules/shared/shared/domain/constants/constants';
import { SET_CONTACT } from '@/modules/users/store/user.mutations';
import { FETCH_CONTACT } from '@/modules/users/store/user.actions';
import PhoneField from '@/modules/shared/shared/components/PhoneField.vue';

@Component({
    components: {
        PhoneField,
    },
})
export default class ModalProfile extends Vue {
    @Prop({ required: true })
    smallScreen!: boolean;
    isSaving: boolean = false;
    modify: boolean = false;
    valid: boolean = false;
    password: string = '';
    confirmationPassword: string = '';
    user: any = {};
    showConfirmationPassword: boolean = false;
    showPassword: boolean = false;
    rules: any = rules;

    mounted() {
        this.setUser();
    }
    setUser() {
        this.user = {
            id: this.contact.id,
            userId: this.storeUser.id,
            name: this.contact.name,
            lastName: this.contact.lastName,
            ci: this.contact.ci,
            company: this.contact.customer.name,
            rol: this.contact.position,
            phone: this.contact.phone,
            cellphone: this.contact.cellphone,
            email: this.contact.email,
        };
    }

    $refs!: {
        form1: any;
        primaryPhone: any;
        secondaryPhone: any;
    };

    dialog: boolean = false;
    async open() {
        this.dialog = true;
        await this.FETCH_CONTACT();
        this.setUser();
    }
    closeDialog() {
        this.dialog = false;
    }
    get userInfoIsSet() {
        return this.$store.state.userInfoIsSet;
    }
    get getIcon() {
        return this.modify ? 'mdi-close' : 'mdi-pencil';
    }

    @Watch('confirmationPassword')
    onConfirmationPasswordChanged() {
        this.validatePassword();
    }
    @Watch('password')
    onPasswordChanged() {
        if (!this.password) {
            this.confirmationPassword = '';
        }
    }

    @Watch('userInfoIsSet')
    onuserInfoIsSetChanged() {
        if (this.userInfoIsSet) {
            this.setUser();
            this.$store.commit('SET_USER_INFO_IS_SET', false);
        }
    }
    async save() {
        if (!this.$refs.primaryPhone.validate() || !this.$refs.secondaryPhone.validate()) return;
        const user: {
            userId: number;
            contactId: number;
            name: string;
            lastName: string;
            ci: string;
            email: string;
            phone: string;
            cellphone: string;
            position: string;
            customerId: number;
            customerName: string;
            contactManagementType: string;
            password: string | null;
            contactType: {
                id: number;
                name: string;
            };
        } = {
            userId: this.user.userId,
            contactId: this.user.id,
            name: this.user.name,
            lastName: this.user.lastName,
            ci: this.user.ci,
            email: this.user.email,
            phone: this.$refs.primaryPhone.correctFormatPhone,
            cellphone: this.$refs.secondaryPhone.correctFormatPhone,
            customerId: this.GET_CUSTOMER_ID,
            customerName: this.user.company,
            position: this.user.rol,
            contactManagementType: ContactManagementType.UPDATE_PROFILE,
            contactType: {
                id: this.contact.contactType,
                name: '',
            },
            password: null,
        };

        const ticket = {
            description: `El contacto ${this.user.name} ${this.user.lastName} del cliente ${this.contact.customer.name} modificó la información del usuario ${this.user.name} ${this.user.lastName}, ${this.user.email} en el Portal de Clientes Daycohost. `,
            ticketType: {
                id: Tickets.REQUIREMENT.id,
                name: TicketType.CONTACT,
            },
            customer: {
                id: this.contact.customer.id,
                name: this.contact.customer.name,
                category: {
                    id: this.contact.customer.category.id,
                },
                contact: {
                    id: this.IS_EMPLOYEE ? undefined : this.user.id,
                    name: this.user.name,
                    lastName: this.user.lastName,
                    identification: this.user.ci,
                    phone: this.user.phone,
                    email: this.user.email,
                },
            },
            contact: user,
        };

        if (this.confirmationPassword) {
            if (this.$refs.form1.validate()) {
                user.password = this.password;
                this.isSaving = true;
                await this.$store.dispatch('updateUserInfo', ticket);
                this.$store.commit('SET_RESET_DIRECTORY', true);
                this.SET_CONTACT(this.user);
                await this.$store.dispatch(
                    'getDirectoryContactsWithAdminInfo',
                    this.contact.customer.id,
                );
                this.isSaving = false;
                this.modify = !this.modify;
                this.$emit('success');
                this.closeDialog();
            }
        } else {
            this.isSaving = true;
            await this.$store.dispatch('updateUserInfo', ticket);
            this.$store.commit('SET_RESET_DIRECTORY', true);
            this.SET_CONTACT(this.user);
            await this.$store.dispatch(
                'getDirectoryContactsWithAdminInfo',
                this.contact.customer.id,
            );
            this.isSaving = false;
            this.modify = !this.modify;
            this.$emit('success');
            this.closeDialog();
        }
    }

    validatePassword() {
        this.$refs.form1.validate();
        if (!this.password) {
            this.confirmationPassword = '';
        }
    }

    get passwordsMatch() {
        if (this.password != this.confirmationPassword && this.confirmationPassword) {
            return 'Las contraseñas no coinciden';
        } else return '';
    }

    @user.Getter(GET_CUSTOMER_ID) GET_CUSTOMER_ID;
    @user.State('contact') contact;
    @user.Getter(IS_EMPLOYEE) IS_EMPLOYEE;
    @user.State('user') storeUser;
    @user.Mutation(SET_CONTACT) SET_CONTACT!: (user: {}) => void;
    @user.Action(FETCH_CONTACT) FETCH_CONTACT;
}
